// src/managerPortal/components/common/DeleteButton.js
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import "../../styles/Buttons.css";

const DeleteButton = ({ onClick }) => {
    return (
        <button onClick={onClick} className="btn-icon btn-delete" title="Delete">
            <FontAwesomeIcon icon={faTrashCan} />
        </button>
    );
};

export default DeleteButton;
